exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".saved-actions[data-v-95323be8]{margin-top:2rem;justify-content:space-between;display:flex}", ""]);

// exports
